export default { 
    interestsList : [
        'Alpaca', 'Bees', 'Bison', 'Cattle/Beef', 'Dairy',
        'Deer', 'Elk', 'Goat', 'Horse', 'Llama', 'Pigs',
        'Poultry', 'Ostrich', 'Sheep', 'Plant/Garden', 'Vineyard',
        'Other', 'Exclusion', 'Fence Contacting'
    ],
    alertStatus : false
}


// WEBPACK FOOTER //
// ./src/store/state.js